import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SetupPreview } from './attendance.types';

@Component({
  selector: 'app-attendance-draft-table', standalone: true,
  imports: [CommonModule],
  templateUrl: './attendance-draft-table.component.html',
  styleUrls: ['./attendance-common.css', './attendance-draft-table.component.css'],
})
export class AttendanceDraftTableComponent {
  @Input() targets: SetupPreview['targets']=[];
  @Input() selected=new Set<string>();
  @Input() disabled=false;
  @Output() selection = new EventEmitter<{id:string;checked:boolean}>();
  @Output() all = new EventEmitter<boolean>();

  previewOrganization(person: SetupPreview['targets'][number]): string {
    return person.org_path?.map(n => n.name).join(' / ') || person.representative_org_name || '所属未設定';
  }

}
